<template>
  <div class="app-container bj-label-colon label-width-7 bj-el-input-disabled app-container-2022-2-9-11-42-08">
    <div class="tabs isFixed">
      <div class="tabs-btn">
        <!-- 编辑 -->
        <el-button v-if="$route.query.type=='edit' && routeStatus === 4 && ![0,2,3,5].includes(routeOrderHandleStatus) && !isUrgent && $route.query.tabName != 'waitHunter'" :disabled="suspendStatus=='21201'" type="primary" @click="onEditOrder">{{ $t('editText') }}</el-button>
        <!-- 取消订单-->
        <el-button
          v-if="(orderInfoVO.orderStatus == 0 || orderInfoVO.orderStatus == 3)
          && (orderInfoVO.sapOrderStatus!=1 || orderInfoVO.sapOrderStatus!=2)
          && routeStatus === 4 && ![0,2,3,5].includes(routeOrderHandleStatus)
          && !isUrgent && $route.query.tabName != 'waitHunter'"
          type="primary" @click="onCancel">{{ $t('InternalSalesOrderDetails.Cancel') }}</el-button>
        <!-- 挂起 订单下所有商品行当前状态一致时才可以挂起 -->
        <!-- <el-button v-if="suspendStatus!='21201'" type="primary" :disabled="!!orderInfoVO.sapPushTime" @click="onHangUp(true)">{{ $t('InternalSalesOrderDetails.Pending') }}</el-button> -->
        <!-- 解挂 订单状态为挂起时按钮才显示 -->
        <!-- <el-button v-else type="primary" @click="onHangUp(false)">{{ $t('InternalSalesOrderDetails.Unhook') }}</el-button> -->
        <!-- 日志 -->
        <BjLogButton v-if="routeOrderHandleStatus !== 0" type="order" :default-query="{
          innerOrderNo: orderInfoVO.innerOrderNo,
          copyOrigin: orderInfoVO.copyOrigin,
          isUser: false,
          isVisible: [10, 11].includes($store.getters.tenantId) ? 1 : null,
        }" no-permission :title="orderInfoVO.innerOrderNo" api="orderApi" />
        <!-- 返回 -->
        <el-button @click="handleClose">{{ $t('backText') }}</el-button>
        <!-- 取消SAP订单 -->
        <!-- <el-button v-if="orderInfoVO.sapOrderNo" type="primary" @click="CancelSAPOrder">{{ $t('InternalSalesOrderDetails.CancelSap') }}</el-button> -->
        <!-- 复制订单 -->
        <!-- <el-button type="primary" @click="onCopy">{{ $t('InternalSalesOrderDetails.Copy') }}</el-button> -->
      </div>
    </div>
    <div :class="{ 'isFixed2': isFixed }" class="tabs">
      <el-tabs v-model="activeName" @tab-click="tabClick">
        <el-tab-pane v-for="item in catalogue" :key="item.id" :label="item.name" :name="item.id"></el-tab-pane>
      </el-tabs>
    </div>
    <div id="placeholderTabs" class="placeholder-tabs"></div>
    <BjDivider id="orderInfo" right-fixed>{{ this.$t('InternalSalesOrderDetails.Orderinformation') }}
      <template #right> </template>
    </BjDivider>

    <!-- 标签 -->
    <div v-if="orderInfoVO.tags" class="bj-row mt20 tags">
      <!-- <BjTagList :tag-code-array="cptOrderTagCodeList" closable @close="handleCloseTag">
        <el-button @click="onAddTags">{{ $t('InternalSalesOrderDetails.Add') }}</el-button>
      </BjTagList> -->
      <BjTagList :tag-code-array="cptOrderTagCodeList"></BjTagList>
    </div>

    <!-- 订单信息 -->
    <div class="bj-row mt20 padding-no fix">
      <!-- 基础信息 -->
      <div class="bj-col bj-col-12">
        <div class="bj-form-title">
          {{ $t('InternalSalesOrderDetails.Basic') }}
          <span v-if="operationType==1" class="link right" @click="onEditAbnormal">{{ $t('InternalOrder.form.AbnormalCause') }}</span>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.type') }}</div>
          <div class="bj-form-item-value">
            {{ $t(ORDER_BUSINESS_TYPE_LIST.bjGet(orderInfoVO.businessType)) }}
          </div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.Order') }}</div>
          <div class="bj-form-item-value">
            {{ $t(ORDER_INTERNAL_ALL_STATUS_LIST.bjGet(totalOrderStatus)) }}
          </div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.party') }}</div>
          <div class="bj-form-item-value">
            <span class="link" @click="$toBusinessThirdOrderView(orderInfoVO.outerOrderNo)">{{ orderInfoVO.webReference }}</span>
            <BjCopyIcon :copy="orderInfoVO.webReference" />
          </div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('InternalOrder.form.wmsOrderNo') }}</div>
          <div class="bj-form-item-value">
            <span>{{ orderInfoVO.sapOrderNo }}</span>
            <BjCopyIcon :copy="orderInfoVO.sapOrderNo" />
          </div>
        </div>
        <div class="bj-form-item" v-if="orderInfoVO.storeCode == 'CO00000658'">
          <div class="bj-formItemLabel">{{ $t('DetailsOfThirdPartySalesOrder.dodgeCompany') }}</div>
          <div class="bj-form-item-value">{{ orderInfoVO.ecommerceOrderRef}}</div>
        </div>
        <div class="bj-form-item" v-if="orderInfoVO.storeCode == 'CO00000658'">
          <div class="bj-formItemLabel">{{ $t('DetailsOfThirdPartySalesOrder.dodgeAccount') }}</div>
          <div class="bj-form-item-value">{{ orderInfoVO.siteListingId}}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.Store') }}</div>
          <div class="bj-form-item-value">
            {{ orderInfoVO.storeName }}
            <span class="F68710">（{{ SCHL_CHANNEL_TYPE.bjGet(orderInfoVO.channel) }}）</span>
          </div>
          <!-- <span v-if="$route.query.status!='3'" class="bj-form-item-right link ml5" @click="getLogistics">{{ $t('queryText') }}</span> -->
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.Three') }}</div>
          <div class="bj-form-item-value">{{ orderInfoVO.orderTime | timeFilters(orderInfoVO.orderTime) }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.creation') }}</div>
          <div class="bj-form-item-value">
            {{ orderInfoVO.creationDate | timeOperateTwoHour }}
          </div>
        </div>
        <!-- 送货预约时间：仅 CSG MANUAL 展示 -->
        <div v-if="orderInfoVO.shippingMethod === 'CSG MANUAL'" class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('BusinessThirdOrderAdd.deliveryAppointmentTime') }}</div>
          <div class="bj-form-item-value">
            {{ orderInfoVO.deliveryAppointmentTime | timeFilters(orderInfoVO.deliveryAppointmentTime) }}
          </div>
        </div>
        <!-- <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.Buyer') }}</div>
          <el-tooltip class="bj-form-item-value" effect="dark" :content="orderInfoVO.buyerRemarks" placement="top-start">
            <span class="ellipsis">{{ orderInfoVO.buyerRemarks }}</span>
          </el-tooltip>
          <div v-if="!orderInfoVO.sapPushTime" class="bj-form-item-right link ml5" @click="onEditRemarks('buyerRemarks')">{{ $t('InternalSalesOrderDetails.Modify') }}</div>
        </div> -->
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.Merchant') }}</div>
          <div class="bj-form-item-value order-remark-content">
            <el-tooltip effect="dark" :content="orderInfoVO.orderRemarks" :disabled="!orderInfoVO.orderRemarks" placement="top-start" popper-class="csg-order-remark-tooltip">
              <span class="ellipsis order-remark-text">{{ orderInfoVO.orderRemarks }}</span>
            </el-tooltip>
            <BjCopyIcon v-if="orderInfoVO.orderRemarks" class="link order-remark-copy" :copy="orderInfoVO.orderRemarks" />
          </div>
          <div v-if="[7, 8].includes(routeStatus)" class="bj-form-item-right link" style="font-size: 14px" @click="onEditRemarks('orderRemarks')">{{ $t('InternalSalesOrderDetails.Modify') }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.Customer') }}</div>
          <div class="bj-form-item-value order-remark-content">
            <el-tooltip effect="dark" :content="orderInfoVO.serviceRemarks" :disabled="!orderInfoVO.serviceRemarks" placement="top-start" popper-class="csg-order-remark-tooltip">
              <span class="ellipsis order-remark-text">{{ orderInfoVO.serviceRemarks }}</span>
            </el-tooltip>
            <BjCopyIcon v-if="orderInfoVO.serviceRemarks" class="link order-remark-copy" :copy="orderInfoVO.serviceRemarks" />
          </div>
        </div>
        <!-- 是否指定物流 -->
        <div v-if="orderInfoVO.shippingMethod !== 'CSG MANUAL'&&operationType==1 && routeStatus !== 3" class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('WarehouseManagement.form.isLogisticsSpecified') }}</div>
          <div class="bj-form-item-value">
            <el-switch v-model="info.isLogisticsSpecified" active-color="#082dc3" inactive-color="" @change="offSwitch"></el-switch>
          </div>
        </div>
        <!-- 选择物流信息 -->
        <div v-if="(orderInfoVO.shippingMethod == 'CSG MANUAL'||orderInfoVO.shippingMethod == 'CUSTOMER MANUAL')&&info.isLogisticsSpecified" class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('WarehouseManagement.form.chooseLogistics') }}</div>
          <div class="bj-form-item-value">
            <span class="ellipsis" v-if="operationType!=1">{{ orderInfoVO.logisticsName }}</span>
            <BjSelectLov v-else v-model="orderInfoVO.logisticsName" :option-list="LogisticsSelectionData" :clearable="false" @change="logsome" />
          </div>
        </div>
        <!-- shipping method -->
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('BusinessPurchaseOrder2.means') }}</div>
          <div class="bj-form-item-value">
              {{ info.isLogisticsSpecified && orderInfoVO.logisticsName ? orderInfoVO.shippingMethod + ' (' + orderInfoVO.logisticsName + ')' : orderInfoVO.shippingMethod }}
          </div>
        </div>
        <!-- 附件 -->
        <template>
          <div class="file">
            <div class="order-material-content">
              <div class="bj-formItemLabel">{{ $t('OrdinaryOrderMix.LogisticsTable.Supporting') }}:</div>
              <div v-if="!isOrderMaterialEdit" class="fileUpload">
                <div v-for="(item, index) in info.orderInfoVO.orderMaterialList" :key="index" class="fileUpload_right">
                  <div class="ellipsis link" @click="downloadImageUrl(item.fileUrl, item.fileName)"><span>file{{ index + 1 }}: </span> {{ item.fileName }}</div>
                </div>
              </div>
              <div v-else class="fileUpload2 order-material-upload">
                <UploadFile
                  ref="UploadOrderMaterialRef"
                  class="avatar-uploader"
                  :limit="20"
                  :limit-size="5 * 1024"
                  multiple
                  show-file-list
                  accept="image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx"
                  :accept-list="['image/jpeg', 'image/png', '.csv', '.pdf', '.doc', '.xlsx']"
                  auto-upload
                  limit-hide
                  @handleFileListChange="fileListChangeOrderMaterial"
                >
                  <template slot="default">
                    <el-button size="small" type="primary">{{ $t('BusinessImportHistory.page.SelectFile') }}</el-button>
                  </template>
                </UploadFile>
              </div>
            </div>
            <div class="order-material-actions">
              <span v-if="$store.getters.cusId && !isOrderMaterialEdit && routeStatus!=4" class="link order-material-action" @click="showOrderMaterialEdit">{{ $t('InternalSalesOrderDetails.Modify') }}</span>
              <span v-if="isOrderMaterialEdit" class="link order-material-action" @click="saveOrderMaterial">{{ $t('saveText') }}</span>
              <span v-if="isOrderMaterialEdit" class="link order-material-action" @click="cancelOrderMaterialEdit">{{ $t('cancelText') }}</span>
            </div>
          </div>
        </template>
      </div>
      <!-- 买家及收货信息(新) operationType : 1.推送异常，0.预占超时 -->
      <buyerInfoDialog :receiver-info-v-o="info.receiverInfoVO" :is-show-edit="operationType==1 || (routeStatus === 8&&orderInfoVO.shippingMethod == 'CSG MANUAL'&&$route.query.type=='edit')" @saveReceiverInfo="saveReceiverInfo" />
      <!-- 买家及收货信息(旧) operationType : 1.推送异常，0.预占超时 -->
      <!-- <receivingInformation :receiver-info-v-o="info.receiverInfoVO" :is-show-edit="operationType==1" :is-reciver-edit="isReciverEdit" @onEditReceiverInfo="onEditReceiverInfo" @saveReceiverInfo="saveReceiverInfo" @cancelReceiverInfo="cancelReceiverInfo"/> -->
    </div>
    <!-- shipping label -->
    <template>
      <BjDivider id="shippingLabel"> {{ $t('InternalSalesOrderDetails.shippingLabel') }} </BjDivider>
      <div class="bj-row mt20">
        <div class="bj-col bj-col-12">
          <div class="bj-form-title">
            <span class="link right" v-if="info.orderInfoVO.shippingLabels && info.orderInfoVO.shippingLabels.length>0" style="margin-left:10px;" @click="batchDownLoad">{{ $t('downloadText') }}</span>
            <!-- CSG MANUAL 用户端没有修改权限 -->
            <span v-if="((![4,5,7,8].includes(routeStatus) && !isOrderInfoVOEdit && logisticsInfoObj.logisticsStatus != 2)||(routeStatus === 8 && $route.query.type == 'edit')) && orderInfoVO.shippingMethod === 'CUSTOMER MANUAL'" style="margin-left:10px;" class="link right" @click="showOrderInfoVOEdit">{{ $t('InternalSalesOrderDetails.Modify') }}</span>
            <span v-if="isOrderInfoVOEdit" class="link right" style="margin-left:10px;" @click="saveShippingLabelInfo">{{ $t('saveText') }}</span>
            <span v-if="isOrderInfoVOEdit" class="link right" @click="isOrderInfoVOEdit = false">{{ $t('cancelText') }}</span>
          </div>
          <div class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('BusinessPurchaseOrder2.means') }}</div>
            <div class="bj-form-item-value">
              <span>{{ orderInfoVO.shippingMethod }}</span>
            </div>
          </div>
          <template v-if="orderInfoVO.shippingMethod === 'CSG MANUAL' || orderInfoVO.shippingMethod === 'CUSTOMER MANUAL'">
            <div class="bj-form-item">
              <div class="bj-formItemLabel">{{ $t('WarehouseManagement.form.chooseLogistics') }}</div>
              <div class="bj-form-item-value">
                <div class="bj-col-12">
                  <span v-if="!isOrderInfoVOEdit">{{ logisticsInfoObj.logisticsBusinessName }}</span>
                  <BjSelectLov v-else v-model="logisticsInfoObj.logisticsBusinessName" :option-list="LogisticsSelectionData" @change="changeLogistics" />
                </div>
              </div>
            </div>
            <div class="bj-form-item" v-if="orderInfoVO.shippingMethod === 'CSG MANUAL'">
              <div class="bj-formItemLabel">{{ $t('billingPage.Carrie') }}{{ $t('BusinessOrderAuditComSkuList.transPrice') }}</div>
              <div class="bj-form-item-value">
                <div class="bj-col-12">
                  <span v-if="!isOrderInfoVOEdit">{{ logisticsInfoObj.totalPrice }}</span>
                  <BjInputMoney v-else v-model="logisticsInfoObj.totalPrice" clearable />
                </div>
              </div>
            </div>
            <div class="bj-form-item">
              <div class="bj-formItemLabel">{{ $t('OrdinaryOrderMix.LogisticsTable.logisticsNo') }}</div>
              <div class="bj-form-item-value">
                <div class="bj-col-12">
                  <span v-if="!isOrderInfoVOEdit">{{ logisticsInfoObj.logisticsNo }}</span>
                  <BjInput v-else v-model="logisticsInfoObj.logisticsNo" clearable />
                </div>
              </div>
            </div>
          </template>

          <!-- 物流单 -->
          <template>
            <div v-if="!isOrderInfoVOEdit" class="file" style="line-height:1.5">
              <div class="bj-formItemLabel">{{ $t('OrdinaryOrderMix.LogisticsTable.Shipment') }}:</div>
              <div class="fileUpload">
                <div v-for="(item, index) in info.orderInfoVO.shippingLabels" :key="index" class="flex">
                  <span>file{{ index + 1 }}:</span>
                  <div style="width: 350px;" class="ellipsis">{{ item.name }}</div>
                </div>
              </div>
            </div>
            <template v-else>
              <div class="font12">
                <div class="bj-formItemLabel">{{ $t('OrdinaryOrderMix.LogisticsTable.Shipment') }}:</div>
              </div>
              <div class="fileUpload2">
                <UploadFile
                  ref="UploadFileRef"
                  class="avatar-uploader"
                  :limit="20"
                  :limit-size="5 * 1024"
                  multiple
                  show-file-list
                  accept="image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx"
                  :accept-list="['image/jpeg', 'image/png', '.csv', '.pdf', '.doc', '.xlsx']"
                  auto-upload
                  limit-hide
                  @handleFileListChange="fileListChange"
                >
                  <template slot="default">
                    <el-button size="small" type="primary">{{ $t('BusinessImportHistory.page.SelectFile') }}</el-button>
                  </template>
                </UploadFile>
              </div>
            </template>
        </template>
        </div>
        <div class="bj-col bj-col-12">
          <div class="bj-form-title">
            {{ $t('WarehouseManagement.form.chooseLogistics') }}
          </div>
          <!-- 'CSG MANUAL' 审核报价 -->
          <div v-if="orderInfoVO.shippingMethod=='CSG MANUAL'" class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('WarehouseManagement.form.isQuotation') }}</div>
            <div class="bj-form-item-value">
              <el-switch v-model="orderInfoVO.isNeedQuota" disabled active-color="#082dc3" inactive-color=""></el-switch>
            </div>
          </div>
          <!-- 'CSG MANUAL' 报价金额 -->
          <div v-if="orderInfoVO.shippingMethod=='CSG MANUAL'" class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('WarehouseManagement.form.amount') }}</div>
            <div class="bj-form-item-value">
              <!-- <BjInputNumber v-model="orderInfoVO.quotedAmount" disabled clearable /> -->
              <div class="bj-form-item-value">{{ orderInfoVO.quotedAmount}} AUD</div>
            </div>
          </div>
          <!-- 'CSG MANUAL' 报价状态 -->
          <div v-if="orderInfoVO.shippingMethod=='CSG MANUAL'" class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('WarehouseManagement.form.quotationStatus') }}</div>
            <div class="bj-form-item-value">
              <!-- <BjSelectLov v-model="orderInfoVO.quotaOrNot" disabled :option-list="quotationStatusList" /> -->
              <div class="bj-form-item-value">{{ quotationStatusList.bjGet(orderInfoVO.quotaOrNot)}}</div>
            </div>
          </div>

          <!-- 'CUSTOMER MANUAL' 是否需要仓库提供尺寸信息 -->
          <div v-if="orderInfoVO.shippingMethod=='CUSTOMER MANUAL'" class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('WarehouseManagement.form.check') }}</div>
            <div class="bj-form-item-value">
              <el-switch v-model="orderInfoVO.isProvideSize" disabled active-color="#082dc3" inactive-color=""></el-switch>
            </div>
          </div>
          <!-- 'CUSTOMER MANUAL' 尺寸是否填写 -->
          <div v-if="orderInfoVO.shippingMethod=='CUSTOMER MANUAL'" class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('WarehouseManagement.form.filled') }}</div>
            <div class="bj-form-item-value">
              <el-switch v-model="sizeIsFillIn" disabled active-color="#082dc3" inactive-color=""></el-switch>
            </div>
          </div>
          <!-- 'CUSTOMER MANUAL' 长 -->
          <div v-if="orderInfoVO.shippingMethod=='CUSTOMER MANUAL'&&sizeIsFillIn" class="bj-form-item">
            <div class="bj-formItemLabel">{{$t('WarehouseManagement.form.Length')}}</div>
            <div class="bj-form-item-value">
              <div class="bj-form-item-value">{{ orderInfoVO.repLength}} cm</div>
            </div>
          </div>
          <!-- 'CUSTOMER MANUAL' 宽 -->
          <div v-if="orderInfoVO.shippingMethod=='CUSTOMER MANUAL'&&sizeIsFillIn" class="bj-form-item">
            <div class="bj-formItemLabel">{{$t('WarehouseManagement.form.Width')}}</div>
            <div class="bj-form-item-value">
              <div class="bj-form-item-value">{{ orderInfoVO.repWidth}} cm</div>
            </div>
          </div>
          <!-- 'CUSTOMER MANUAL' 高 -->
          <div v-if="orderInfoVO.shippingMethod=='CUSTOMER MANUAL'&&sizeIsFillIn" class="bj-form-item">
            <div class="bj-formItemLabel">{{$t('WarehouseManagement.form.Height')}}</div>
            <div class="bj-form-item-value">
              <div class="bj-form-item-value">{{ orderInfoVO.repHeight}} cm</div>
            </div>
          </div>
          <!-- 'CUSTOMER MANUAL' 重 -->
          <div v-if="orderInfoVO.shippingMethod=='CUSTOMER MANUAL'&&sizeIsFillIn" class="bj-form-item">
            <div class="bj-formItemLabel">{{$t('WarehouseManagement.form.Weight')}}</div>
            <div class="bj-form-item-value">
              <div class="bj-form-item-value">{{ orderInfoVO.repWeight}} kg</div>
            </div>
          </div>
          <!-- 'CUSTOMER MANUAL' 需要托盘数量 -->
          <div v-if="orderInfoVO.shippingMethod=='CUSTOMER MANUAL'" class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('WarehouseManagement.form.need') }}</div>
            <div class="bj-form-item-value">
              <!-- <BjInputNumber v-model="orderInfoVO.palletQty" disabled clearable /> -->
              <div class="bj-form-item-value">{{ orderInfoVO.palletQty}}</div>
            </div>
          </div>
          <!-- 'CUSTOMER MANUAL' 预计取货时间 -->
          <div v-if="orderInfoVO.shippingMethod=='CUSTOMER MANUAL'" class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('WarehouseManagement.form.time') }}</div>
            <div class="bj-form-item-value">
              <!-- <BjDateTimerPicker v-model="orderInfoVO.truckPickupTime" disabled /> -->
              <div class="bj-form-item-value">{{ orderInfoVO.truckPickupTime | timeFilters(orderInfoVO.truckPickupTime) }}</div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- 图片信息 -->
    <BjDivider id="imgInfo" v-if="ImgData.length>0">{{ this.$t('InternalSalesOrderDetails.Image') }} </BjDivider>
    <div class="bj-row mt20" v-if="ImgData.length>0">
      <div class="bj-col bj-col-24 flex-align relative">
        <div v-for="(item,key) in pdfData" :key="key" style="position:absolute;top:0;left:0;font-size: 14px;">
          <a :href="`${item.detailImage}`" target='_blank' download style="color:#409eff">{{ $t('downloadText') + 'PDF'}}</a>
        </div>
        <div style="width:22%;margin:0 10px;" v-for="(item,key) in ImgData" :key="key">
          <BjKeyImage v-if="item.imageType == 'Signature' || item.imageType == 'OrderPdf'" width="100%" height="120px" url="https://minio.wooper.com/test/10/1728874350587_14T9R1MV.png" preview />
          <BjKeyImage v-else width="100%" height="200px" :url="checkUrl(item.detailImage)" preview />
        </div>
      </div>
    </div>
    <!-- 商品信息 -->
    <BjDivider id="goodsInfo">{{ this.$t('InternalSalesOrderDetails.Product') }} </BjDivider>
    <div class="bj-row mt20">
      <div class="bj-col bj-col-24">
        <GoodsInfoTab v-if="tabVisible" ref="GoodsInfoTab" :order-id="id" :inner-order-no="orderInfoVO.innerOrderNo" :order-status="orderInfoVO.orderStatus" has-btn :business-type="businessType" @reFresh="reFresh" @afterFetchOriginalData="afterFetchOriginalData" />
      </div>
    </div>

    <!-- 物流信息 -->
    <template>
      <BjDivider id="logisticsInfo">{{ this.$t('InternalSalesOrderDetails.Logistics') }} </BjDivider>
      <div class="bj-row mt20">
        <LogisticsTable ref="LogisticsInfo" has-btn :data-info="info" />
      </div>
    </template>
    <EditRemarks :id="id" ref="EditRemarks" :info="orderInfoVO" @editBaseInfoApi="editBaseInfoApi" />
    <EditReceiverInfo :id="id" ref="EditReceiverInfo" :info="info.receiverInfoVO" @editBaseInfoApi="editBaseInfoApi" />
    <SuspendReason :id="id" ref="SuspendReason" @reFresh="reFresh" />
    <EditTags :id="id" ref="EditTags" :tags="cptOrderTagCodeList" @editBaseInfoApi="editBaseInfoApi" />
    <!--    物流业务弹窗-->
    <BjDialog :title="$t('routeBusinessStockDeliveryInformView.business')" :visible="logistics_visible" width="600px" @close="logistics_visible = false">
      <bj-table ref="BjTable" :loading="false" :list="dialogListConfig.columns" :serial="true" :is-pagination="false">
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
              <template slot-scope="{ row }">
                <template v-if="false" />
                <el-switch v-else-if="col.prop === 'isEnable'" v-model="row[col.prop]" disabled></el-switch>
                <span v-else>{{ row[col.prop] | timeFilters(row[col.prop]) }}</span>
              </template>
            </el-table-column>
          </template>
        </template>
      </bj-table>
    </BjDialog>
    <el-dialog :title="$t('routeBusinessStockDeliveryInformView.go')" :visible.sync="isShow" width="500px" :before-close="handleClose">
      <div class="flex-align">
        <div v-for="(item,index) in viewData" :key="index" @click="goThirdView(item)"><el-link type="primary">{{ item }}</el-link>
          <span v-if="viewData.length-1!=index" style="color:black">，</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShow = false">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="goCopyPage()">{{ $t('InternalSalesOrderDetails.Resend') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import viewMiXin from '@/utils/view-mixin.js';
import { orderApi, channelApi, logisticApi, settingApi} from '@/api';
import GoodsInfoTab from './GoodsInfoTab';
import BjDialog from '@/packages/BjDialog';

import LogisticsTable from './LogisticsTable';
import EditRemarks from './EditRemarks';
import EditReceiverInfo from './EditReceiverInfo';
import SuspendReason from './SuspendReason';
import EditTags from '@/views/center-business/csgOrder/order/components/EditTags';
import receivingInformation from '@/components/order/receivingInformation';
import buyerInfoDialog from '@/components/order/buyerInfoDialog';
import UploadFile from '@/views/center-business/third/csg/order/components/UploadFile';
import { events_config } from '@/utils';
import {
  ORDER_TRADE_TYPE_LIST,
  ORDER_BUSINESS_TYPE_LIST,
  ORDER_ACTION_TYPE_LIST,
  STATUS_HAVE_TRUE,
  ORDER_INTERNAL_ALL_STATUS_LIST,
  ORDER_INTERNAL_PREEMPT_BACK_STATUS_LIST,
  ORDER_INTERNAL_SOURCE_STATUS_LIST,
  //
  ORDER_INTERNAL_PAYMENT_LIST,
  ORDER_INTERNAL_PAYMENT_STATUS_LIST,
  ORDER_DECRYPT_NAME,
} from '@/utils/constants';
import { getOffsetTop } from '@/utils';
const DUPLICATE_TRACKING_CODE = 'Tracking number already exists. It may be a combined shipment. Please verify before adding.';
const getDefaultForm = () => {
  return {
    orderStatusTotalVO: {
      finishCount: null,
      unfinishedCount: null,
      cancelCount: null,
    },
    unfinishedTotalVO: {
      outStockCount: null,
      failSeekCount: null,
      waitSendCount: null,
      preempAuditCount: null,
      seekAuditCount: null,
    },
    waitDealTotalVO: {
      outStockCount: null,
      failSeekCount: null,
      failSyncPreempCount: null,
      failSyncSendCount: null,
      waitAudit: null,
    },
    orderInfoVO: {
      id: null,
      orderStatus: null,
      tradeType: null,
      outerOrderNo: null,
      innerOrderNo: null,
      storeName: null,
      storeCode: null,
      orderTime: null,
      creationDate: null,
      deliveryAppointmentTime: null,
      orderRemarks: null,
      buyerRemarks: null,
      serviceRemarks: null,
      shippingMethod: null,
      shippingLabels: [],
      isProvideSize: false,
      palletQty: null,
      truckPickupTime: null,
    },
    receiverInfoVO: {
      buyerNick: null,
      receiverName: null,
      phone: null,
      mobile: null,
      province: null,
      city: null,
      district: null,
      address: null,
    },
    amountInfoVO: {
      goodsTotalAmount: null,
      buyerPayAmount: null,
      costAmount: null,
    },
    paymentInfoVO: {
      payType: null,
      payStatus: null,
      payTime: null,
      payAmount: null,
    },
  };
};

export default {
  name: 'BusinessOrderInternalViewForm',
  components: {
    GoodsInfoTab,
    LogisticsTable,
    EditRemarks,
    EditReceiverInfo,
    SuspendReason,
    EditTags,
    BjDialog,
    receivingInformation,
    buyerInfoDialog,
    UploadFile
  },
  mixins: [viewMiXin, pageMiXin],
  props: {
    businessType: {
      type: String,
      default: '',
    },
  },
  provide() {
    return { getInfo: () => this.info };
  },
  data() {
    return {
      ORDER_TRADE_TYPE_LIST,
      ORDER_BUSINESS_TYPE_LIST,
      ORDER_ACTION_TYPE_LIST,
      STATUS_HAVE_TRUE,
      ORDER_INTERNAL_ALL_STATUS_LIST,
      ORDER_INTERNAL_PREEMPT_BACK_STATUS_LIST,
      ORDER_INTERNAL_SOURCE_STATUS_LIST,
      //
      ORDER_INTERNAL_PAYMENT_LIST,
      ORDER_INTERNAL_PAYMENT_STATUS_LIST,
      ORDER_DECRYPT_NAME,

      info: getDefaultForm(),
      // 表单校验
      rules: {},
      activeName: 'orderInfo',
      isFixed: false,
      tabVisible: true,
      logistics_visible: false,
      dialogListConfig: {
        columns: []
      },
      labelList: [
        { label: 'businessLogisticsCompany.table.status', prop: 'isEnable', isCheck: true, disabled: false, width: 150 },
        { label: 'businessLogisticsCompany.table.logisticsCompanyName', prop: 'logisticsName', isCheck: true, disabled: false },
      ],
      // 物流列表信息
      LogisticsSelectionData: [],
      // 外部订单号弹窗开关
      isShow: false,
      // 外部订单号弹窗信息
      viewData: [],
      isReciverEdit: false,
      logisticsInfoObj: {}, // shipping label 临时存放的 发货单信息
      copyReceiverInfo: {},
      operationType: this.$route.query.operationType || null,
      isOrderInfoVOEdit: false,
      isOrderMaterialEdit: false,
      fileList: [],
      orderMaterialList: [],
      manual: ['CUSTOMER MANUAL', 'PICKUP', 'CSG MANUAL'],
      suspendStatus: '21200',
      // 订单总状态
      totalOrderStatus: '',
      // 图片信息
      ImgData: [],
      pdfData: [],
      // 报价状态
      quotationStatusList:[
        {value: 0, label: this.$t('WarehouseManagement.form.status0')},
        {value: 1, label: this.$t('WarehouseManagement.form.status1')},
        {value: 2, label: this.$t('WarehouseManagement.form.status2')},
        {value: 3, label: this.$t('WarehouseManagement.form.status3')},
      ],
      // 尺寸是否填写
      sizeIsFillIn:false,
    };
  },
  computed: {
    routeStatus() {
      const status = this.$route.query.status;
      if (status === undefined || status === null || status === '') return null;
      const value = Number(status);
      return Number.isNaN(value) ? null : value;
    },
    routeOrderHandleStatus() {
      const status = this.$route.query.orderHandleStatus;
      if (status === undefined || status === null || status === '') return null;
      const value = Number(status);
      return Number.isNaN(value) ? null : value;
    },
    catalogue() {
     const catalogue = [
        // 订单信息
        {
          id: 'orderInfo',
          name: this.$t('InternalSalesOrderDetails.Orderinformation'),
        },
        // shipping label
        {
          id: 'shippingLabel',
          name: this.$t('InternalSalesOrderDetails.shippingLabel')
        },
        // 商品信息
        {
          id: 'goodsInfo',
          name: this.$t('InternalSalesOrderDetails.Product'),
        },
        // 物流信息
        {
          id: 'logisticsInfo',
          name: this.$t('InternalSalesOrderDetails.Logistics'),
        },
      ];
      return catalogue;
    },
    id() {
      return this.info.orderInfoVO.id;
    },
    SCHL_CHANNEL_TYPE() {
      return this.$store.state.values.SCHL_CHANNEL_TYPE || [];
    },
    BJ_TAGS() {
      return this.$store.state.values.BJ_TAGS || [];
    },
    percentage() {
      const done =
        this.orderStatusTotalVO.finishCount || 0 + this.orderStatusTotalVO.cancelCount || 0;
      const all = done + this.orderStatusTotalVO.unfinishedCount || 0 || 1; // 0 不能为除数，默认为1
      return Math.floor(done / all * 100);
    },
    orderStatusTotalVO() {
      return this.info.orderStatusTotalVO || {};
    },
    unfinishedTotalVO() {
      return this.info.unfinishedTotalVO || {};
    },
    waitDealTotalVO() {
      return this.info.waitDealTotalVO || {};
    },
    orderInfoVO() {
      return this.info.orderInfoVO || {};
    },
    amountInfoVO() {
      return this.info.amountInfoVO || {};
    },
    paymentInfoVO() {
      return this.info.paymentInfoVO || {};
    },
    cptOrderTagCodeList() {
      return this.orderInfoVO.tags ? this.orderInfoVO.tags.split(',') : [];
    },
    isUrgent() {
      return this.cptOrderTagCodeList.includes('LB1718612626520-1753039007');
    },
  },
  watch: {},
  created() {
    // 会被接口数据覆盖
    this.orderInfoVO.businessType = this.businessType;
    this.getLogisticsDataList();
    events_config.cancel('getDataOfSearchEvent', false);
    this.totalOrderStatus = this.routeStatus;
  },
  mounted() {
    this.reFresh();
    this.$store.dispatch('values/getValueList', 'SCHL.CHANNEL_TYPE');

    // 对整个页面滚轮进行监听，每发生一次滚轮事件，执行一次方法
    window.addEventListener('scroll', this.scrollCallBack, true);
    events_config.listen('getLogisticsEvent', (data, data2) => {
      this.logisticsInfoObj = data2;
      this.logisticsInfoObj.totalPrice = data2.totalCharge;
    });
  },
  destroyed() {
    // 解绑滚轮监听事件
    window.removeEventListener('scroll', this.scrollCallBack, true);
  },
  methods: {
    // BjKeyImage 组件网址过滤
    checkUrl(url) {
      if (url) {
        if (String(url).indexOf('http') > -1) {
          return url;
        } else {
          return 'https://' + url;
        }
      }
    },
    getImg(){
      orderApi.getThirdOrderDetailImg({outOrderNo: encodeURIComponent(this.info.orderInfoVO.outerOrderNo)}).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.ImgData = res.filter(item=> item.imageType != 'OrderPdf')
          this.pdfData = res.filter(item=> item.imageType == 'OrderPdf')
        }
      });
    },
    changeLogistics(v, item) {
      this.logisticsInfoObj.logisticsCompany = v ? item.label: '';
    },
    afterFetchOriginalData(data) {
      this.suspendStatus = data.content[0].suspendStatus;
    },
    batchDownLoad() {
      this.info.orderInfoVO.shippingLabels.forEach(item => {
        this.downloadImageUrl(item.url, item.name);
      });
    },
    handleShippingLabelSaveSuccess() {
      this.isOrderInfoVOEdit = false;
      setTimeout(() => {
        this.$message.success(this.$t('toast.operationSuccessText'));
        this.reFresh();
        // 重新获取物流信息数据
        this.$refs.LogisticsInfo.reFreshDeliverTable();
      }, 1000);
    },
    // 重复运单号二次确认，用户核实后携带确认参数重新提交
    async submitWithDuplicateTrackingConfirm(request, data) {
      const initialData = { ...data };
      delete initialData.duplicateTrackingConfirmed;
      let response = await request(initialData);
      if (response && response.failed === true && response.type === 'warn' && response.code === DUPLICATE_TRACKING_CODE) {
        try {
          await this.$confirm(this.$t('InternalSalesOrderDetails.duplicateTrackingConfirm'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('InternalSalesOrderDetails.duplicateTrackingVerified'),
            cancelButtonText: this.$t('InternalSalesOrderDetails.duplicateTrackingBack'),
            customClass: 'duplicate-tracking-confirm',
            type: 'warning',
          });
        } catch (error) {
          return null;
        }
        response = await request({ ...initialData, duplicateTrackingConfirmed: true });
      }
      if (response && response.failed) {
        this.$message.error(response.message || response.code);
        return null;
      }
      return response;
    },
    // 提交 shipping label数据
    async saveShippingLabelInfo() {
      let fileUrlList = [];
      if (this.fileList.length > 0) {
        fileUrlList = this.fileList.map(item => {
          return { name: item.name, url: item.url };
        });
      }
      // 在上传面单之前 如果 需要尺寸信息 那么 未填写尺寸信息 则 无法上传面单
      // 不需要尺寸 或 已填写尺寸
      if(!(!this.info.orderInfoVO.isProvideSize||[this.info.orderInfoVO.repLength,this.info.orderInfoVO.repWidth,this.info.orderInfoVO.repHeight,this.info.orderInfoVO.repWeight].every(e=>{return e > 0})))
      return this.$message.error(this.$t('WarehouseManagement.form.not'))

      const data = {
        ...this.logisticsInfoObj,
        outerOrderNo: this.info.orderInfoVO.outerOrderNo,
        innerOrderNo: this.info.orderInfoVO.innerOrderNo
      };
      const DATA = {
        innerOrderNo: this.info.orderInfoVO.innerOrderNo,
        shippingMethod: this.info.orderInfoVO.shippingMethod,
        shippingLabels: JSON.stringify(fileUrlList)
      };
      const status8DATA = {
        innerOrderNo: this.info.orderInfoVO.innerOrderNo,
        logisticsBusinessName: this.logisticsInfoObj.logisticsBusinessName,
        logisticsCompany: this.logisticsInfoObj.logisticsCompany,
        logisticsNo: this.logisticsInfoObj.logisticsNo,
        outerOrderNo: this.orderInfoVO.outerOrderNo,
        shippingLabels: JSON.stringify(fileUrlList),
        totalOrderStatus: this.routeStatus,
        totalPrice: this.logisticsInfoObj.totalPrice,
      };
      if (this.routeStatus === 8) {
        if(this.fileList.length == 0){
          return this.$message.error(this.$t('ExcelConfig.upload'))
        }
        if(this.info.orderInfoVO.shippingMethod === 'CUSTOMER MANUAL'){
          if(!this.logisticsInfoObj.logisticsNo || !this.logisticsInfoObj.logisticsBusinessName){
            return this.$message.error(`${this.$t('InternalReturnRefundNoteDetails.Logistics')} ${this.$t('OrdinaryOrderMix.LogisticsTable.logisticsNo')} ${this.$t('emptyWarningText')}`);
          }
          const response = await this.submitWithDuplicateTrackingConfirm(orderApi.waitingUpdateLabel, status8DATA);
          if (response) this.handleShippingLabelSaveSuccess();
        }
      }else{
        if(this.logisticsInfoObj.logisticsNo && !this.logisticsInfoObj.logisticsBusinessName) return this.$message.error(this.$t('BusinessPurchaseComponentsCom.rules.logisticsBusinessId'));
        if(fileUrlList.length>0 && !this.logisticsInfoObj.logisticsBusinessName) return this.$message.error(this.$t('BusinessPurchaseComponentsCom.rules.logisticsBusinessId'));
        data.totalPrice = 0
        if (!await this.logisticsCsgApi(data)) return;
        if (!await this.shippingInfoApi(DATA)) return;
        this.handleShippingLabelSaveSuccess();
      }
    },
    // 修改CSG手动订单物流信息
    async logisticsCsgApi(data) {
      const response = await orderApi.updateCustomerManualOrderLogistics(data);
      if (response && response.failed) return false;
      this.logisticsInfoObj.logisticsStatus = data.logisticsStatus;
      return true;
    },
    // 订单运输信息修改
    async shippingInfoApi(data) {
      const response = await orderApi.modifyShippingInfo(data);
      return !(response && response.failed);
    },
    showOrderInfoVOEdit() {
      this.isOrderInfoVOEdit = true;
      if (this.info.orderInfoVO.shippingLabels) {
        this.$nextTick(() => {
          if (!this.$refs.UploadFileRef) return;
          this.$refs.UploadFileRef.fileList = this.info.orderInfoVO.shippingLabels;
        });
      }
    },
    // 上传的文件列表
    fileListChange(file) {
          this.fileList = file.filter(item => item.url);
        },
    showOrderMaterialEdit() {
      this.isOrderMaterialEdit = true;
      const orderMaterialList = this.info.orderInfoVO.orderMaterialList || [];
      this.orderMaterialList = orderMaterialList.map(item => ({
        fileName: item.fileName,
        fileUrl: item.fileUrl
      })).filter(item => item.fileUrl);
      this.$nextTick(() => {
        if (!this.$refs.UploadOrderMaterialRef) return;
        this.$refs.UploadOrderMaterialRef.fileList = orderMaterialList.map(item => ({
          name: item.fileName,
          url: item.fileUrl
        }));
      });
    },
    cancelOrderMaterialEdit() {
      this.isOrderMaterialEdit = false;
      this.orderMaterialList = [];
    },
    fileListChangeOrderMaterial(file) {
      this.orderMaterialList = (file || []).map(item => ({
        fileName: item.name,
        fileUrl: item.url
      })).filter(item => item.fileUrl);
    },
    saveOrderMaterial() {
      const DATA = {
        outerOrderNo: this.info.orderInfoVO.outerOrderNo,
        thirdMaterialDTOList: this.orderMaterialList
      };
      orderApi.updateOrderMaterial(DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.isOrderMaterialEdit = false;
          this.orderMaterialList = [];
          this.reFresh();
        }
      });
    },
    // 获取物流下拉信息
    async getLogisticsDataList() {
      logisticApi.getLogisticsBusiness({
          currentPage: 0,
          page: 0,
          pagesize: 999,
          size: 999,
        }).then(res => {
        this.LogisticsSelectionData = res.content.map(item => {
          return {
            label: item.logisticsName,
            value: item.name
          };
        });
      });
    },
    // 选择物流信息后执行方法
    logsome(v, item) {
      orderApi.modifyLogistics({
        isLogisticsSpecified: this.info.isLogisticsSpecified == true ? '1' : '0',
        logisticsName: v,
        innerOrderNo: this.orderInfoVO.innerOrderNo
      });
    },
    // 关闭选择物流信息后执行方法
    offSwitch() {
      if (!this.info.isLogisticsSpecified) {
        orderApi.modifyLogistics({
          isLogisticsSpecified: '0',
          logisticsName: null,
          innerOrderNo: this.orderInfoVO.innerOrderNo
        });
      }
    },
    // 是否自提单 开关方法
    switchPickUp() {
      if (this.info.takingDeliveryWay) {
        orderApi.modifyIsPickUp({
          orderCode: this.orderInfoVO.innerOrderNo,
          takingDeliveryWay: 1,
        });
      } else {
        orderApi.modifyIsPickUp({
          orderCode: this.orderInfoVO.innerOrderNo,
          takingDeliveryWay: 2,
        });
      }
    },
    onEditReceiverInfo() {
      this.isReciverEdit = true;
      this.copyReceiverInfo = JSON.parse(JSON.stringify(this.info.receiverInfoVO));
    },
    cancelReceiverInfo() {
      this.isReciverEdit = false;
      this.info.receiverInfoVO = this.copyReceiverInfo;
    },
    saveReceiverInfo(newReceiverInfo, closeDialog) {
      if (newReceiverInfo) {
        this.info.receiverInfoVO = Object.assign({}, this.info.receiverInfoVO, newReceiverInfo);
      }
      const receiverInfoVO = this.info.receiverInfoVO;
      const countryList = ['TW','HK','MO','SG','GB','IE','IL','IS','AE','MC','BH','VA','SZ','MV','NZ','SM','LI','AD','BS']
      const regex = /^[A-Za-z0-9 \-\'\.,\/#&:;()]+$/
      if ( this.info.orderInfoVO.shippingMethod != 'PICKUP' ){
        if (!receiverInfoVO.receiverName) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryName')}${this.$t('emptyWarningText')}`);
        if (!receiverInfoVO.phone) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryPhone')}${this.$t('emptyWarningText')}`);
        if (!receiverInfoVO.country) return this.$message.warning(`${this.$t('WarehouseManagement.form.country')}${this.$t('emptyWarningText')}`);
        if (!receiverInfoVO.province && !countryList.includes(receiverInfoVO.country)) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryState')}${this.$t('emptyWarningText')}`);
        if (receiverInfoVO.province && !regex.test(receiverInfoVO.province)) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryState')}${this.$t('IncorrectAddressFormatText')}`);
        if (!receiverInfoVO.district) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliverySuburb')}${this.$t('emptyWarningText')}`);
        if (receiverInfoVO.district && !regex.test(receiverInfoVO.district)) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliverySuburb')}${this.$t('IncorrectAddressFormatText')}`);
        if (!receiverInfoVO.zipCode) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryPostcode')}${this.$t('emptyWarningText')}`);
        if (!receiverInfoVO.deliveryAddress1) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryAddress1')}${this.$t('emptyWarningText')}`);
        if (receiverInfoVO.deliveryAddress1 && !regex.test(receiverInfoVO.deliveryAddress1)) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryAddress1')}${this.$t('IncorrectAddressFormatText')}`);
        // if (!receiverInfoVO.deliveryAddress2) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryAddress2')}${this.$t('emptyWarningText')}`);
        if (receiverInfoVO.deliveryAddress2 && !regex.test(receiverInfoVO.deliveryAddress2)) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryAddress2')}${this.$t('IncorrectAddressFormatText')}`);
        if (receiverInfoVO.deliveryEmailAddress) {
          if (!receiverInfoVO.deliveryEmailAddress.includes('@')) return this.$message.warning(this.$t('personal.emailErrorMsg2'));
        }
      }else{
        if (receiverInfoVO.province) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryState')} ： ${this.$t('ExternalOrders.addressTips')}`);
        if (receiverInfoVO.district) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliverySuburb')} ： ${this.$t('ExternalOrders.addressTips')}`);
        if (receiverInfoVO.zipCode) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryPostcode')} ： ${this.$t('ExternalOrders.addressTips')}`);
        if (receiverInfoVO.deliveryAddress1) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryAddress1')} ： ${this.$t('ExternalOrders.addressTips')}`);
        if (receiverInfoVO.deliveryAddress2) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryAddress2')} ： ${this.$t('ExternalOrders.addressTips')}`);
        if (receiverInfoVO.deliveryEmailAddress) {
          if (!receiverInfoVO.deliveryEmailAddress.includes('@')) return this.$message.warning(this.$t('personal.emailErrorMsg2'));
        }
      }
      orderApi.modifyReceiverinfo({...this.info.receiverInfoVO, innerOrderNo: this.orderInfoVO.innerOrderNo}).then(() => {
        this.isReciverEdit = false;
        this.$refs.LogisticsInfo.reFreshDeliverTable();
        // 验证通过，关闭弹窗
        closeDialog && closeDialog();
      });
    },
    // 获取物流业务
    getLogistics() {
      this.logistics_visible = true;
      this.getLogisticsConfigByShopCode();
    },
    // 根据网店code获取网店物流配置列表
    getLogisticsConfigByShopCode() {
        channelApi.getLogisticsConfigByShopCode({ shopCode: this.orderInfoVO.storeCode }).then(res => {
          this.dialogListConfig.columns = res;
      });
    },
    scrollCallBack() {
      // 兼容性，获取页面滚动距离
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // 获取浏览器高度
      const windowHeight = window.innerHeight;

      // 判断开始浮动
      const StartFixedHeight = getComputedStyle(
        document.getElementsByClassName('app-container')[0],
      )['paddingTop'].replace('px', '');
      this.isFixed = scrollTop > StartFixedHeight;

      // tabs浮动后，占位
      const placeholderTabs = document.getElementById('placeholderTabs'); // 这是一个占位元素，高度与tab相等，用于tab脱离文档流后，用此占位，防止抖动
      const TabsHeight = document.getElementsByClassName('tabs')[0].offsetHeight || 0;
      placeholderTabs.style.height = this.isFixed ? TabsHeight + 'px' : '0px';

      // 标签的active回写
      this.catalogue.forEach((v, i) => {
        // 获取元素本身离文档顶部高度（这个数据不会改变）
        const offsetTop = getOffsetTop(document.getElementById(`${v.id}`));
        // 如果  元素本身离文档顶部高度offsetTop  - dom滚动距离 =  元素当前离浏览器（可视）顶部的距离
        // 元素当前离浏览器（可视）顶部的距离如果不到2/3屏（到底部为1/3屏），则激活标签
        if (offsetTop - scrollTop < windowHeight / 2) {
          // 导航栏背景色选中
          this.activeName = v.id;
        }
      });
    },
    /* ************************ 按钮事件 *****************************/
    // 取消订单
    onCancel() { // sapOrderStatus 0正在推送sap，1推送成功，6取消sap中，2已发货
      let messageTip = this.$t('InternalSalesOrderDetails.want');
      if (this.orderInfoVO.sapPushTime) return this.$message.warning(this.$t('InternalSalesOrderDetails.OrderAwaiting2'));
      if (this.orderInfoVO.sapOrderStatus == 2) {
        messageTip = this.$t('InternalSalesOrderDetails.orderShipped');
      }
      this.$confirm(messageTip).then(_ => {
          this.$refs.LogisticsInfo.CancelLogistics();
          if (this.routeStatus === 3) {
            // 当订单状态为 处理中订单 时 ==>  判断是否可以编辑
            orderApi.getOrderSapStatus({ innerOrderNo: encodeURIComponent(this.orderInfoVO.innerOrderNo) }).then(res => {
              if (res.failed === false) {
                orderApi.cancelInternalOrder({ innerOrderNo: this.orderInfoVO.innerOrderNo }).then(res => {
                  if (res.failed === false) {
                    this.$message.success(this.$t('toast.operationSuccessText'));
                    setTimeout(() => {
                      this.reFresh();
                    }, 500);
                  }
                });
              }
            });
          } else {
            orderApi.cancelInternalOrder({ innerOrderNo: this.orderInfoVO.innerOrderNo }).then(res => {
              if (res.failed === false) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.reFresh();
                }, 500);
              }
            });
          }
      });
    },

    // 取消SAP订单
    CancelSAPOrder() {
      this.$confirm(this.$t('InternalSalesOrderDetails.want'))
        .then(_ => {
          orderApi
            .cancelInternalSAPOrder({ innerOrderNo: this.orderInfoVO.innerOrderNo })
            .then(res => {
              if (res.failed === false) {
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.reFresh();
                }, 500);
              }
            });
        })
        .catch(_ => {});
    },

    command(TEXT) {
      this.$confirm(this.$t('InternalSalesOrderDetails.Operation'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          // 仅退款单页面
          if (TEXT === this.$t('InternalSalesOrderDetails.Create')) {
            this.$router.push({
              name: 'BusinessAfterInternalRefundAdd',
              query: { innerOrderNo: this.orderInfoVO.innerOrderNo },
            });
          }
          // 重发单页面
          if (TEXT === this.$t('InternalSalesOrderDetails.Resend')) {
            orderApi.getResendList({outerOrderNo: this.orderInfoVO.outerOrderNo}).then(res => {
              // console.log(res,'outerorder');
              if (res.length) {
                this.isShow = true;
                const arr = res;
                this.viewData = arr;
              } else {
                this.$router.push({
                name: 'BusinessThirdCopyOrderView',
                query: { innerOrderNo: this.orderInfoVO.innerOrderNo },
              });
              }
            });
          }
          // 补发单页面
          if (TEXT === this.$t('InternalSalesOrderDetails.Reissue')) {
            this.$router.push({
              name: 'BusinessThirdReissueOrderView',
              query: { innerOrderNo: this.orderInfoVO.innerOrderNo },
            });
          }
        })
        .catch(() => {});
    },
    // 跳转外部详情页
    goThirdView(e) {
      this.$toBusinessThirdOrderView(e, false);
    },
    // 跳转重发单
    goCopyPage() {
      this.$router.push({
      name: 'BusinessThirdCopyOrderView',
      query: { innerOrderNo: this.orderInfoVO.innerOrderNo },
      });
    },

    tabClick({ name }) {
      const fixedHeaderHeight =
        document.getElementsByClassName('fixed-header')[0].offsetHeight || 0;
      const tabsHeight = document.getElementsByClassName('tabs')[0].offsetHeight || 0;

      const setDocumentScrollFn = v => {
        document.documentElement.scrollTop = v;
      };
      const ANCHOR = document.getElementById(name);
      const TO_DISTANCE = getOffsetTop(ANCHOR) - fixedHeaderHeight - tabsHeight;
      const FROM_DISTANCE = document.documentElement.scrollTop;
      let nowDistance = FROM_DISTANCE;
      const step = 50;
      smoothFn();
      function smoothFn() {
        if (FROM_DISTANCE < TO_DISTANCE) {
          nowDistance += step;
          if (nowDistance < TO_DISTANCE) {
            setTimeout(smoothFn, 10);
          } else {
            nowDistance = TO_DISTANCE;
          }
          setDocumentScrollFn(nowDistance);
        } else {
          nowDistance -= step;
          setDocumentScrollFn(nowDistance);
          if (nowDistance > TO_DISTANCE) {
            setTimeout(smoothFn, 10);
          } else {
            nowDistance = TO_DISTANCE;
          }
          setDocumentScrollFn(nowDistance);
        }
      }
    },
    /* ************************ 按钮事件 *****************************/
    reFresh(goodsInfoActiveTab) {
      const orderId = this.$route.query.id;
      const orderCode = this.$route.query.code;

      orderApi
        .getInternalDetailByIdCode({
          orderCode,
          orderId,
        })
        .then(res => {
          this.info = {
            ...this.info,
            ...(res || {}),
            takingDeliveryWay: res.orderInfoVO.takingDeliveryWay == 1,
            isLogisticsSpecified: res.orderInfoVO.isLogisticsSpecified == 1,
          };
          this.info.orderInfoVO.shippingLabels = res.orderInfoVO.shippingLabels ? JSON.parse(res.orderInfoVO.shippingLabels) : [];
          this.info.orderInfoVO.orderMaterialList = res.orderInfoVO.orderMaterialList || [];
          // 通过长宽高重是否有值来判断，尺寸是否填写
          this.sizeIsFillIn = [this.info.orderInfoVO.repLength,this.info.orderInfoVO.repWidth,this.info.orderInfoVO.repHeight,this.info.orderInfoVO.repWeight].every(e=>{return e > 0})
          if (this.manual.includes(this.orderInfoVO.shippingMethod.toUpperCase())) {
            events_config.trigger('getDataOfSearchEvent', false);
          } else {
            events_config.trigger('getDataOfSearchEvent', true);
          }
          this.getImg();
        });

      this.reTabs(goodsInfoActiveTab);
    },
    changeTabs(tab, event) {
      this.$refs.carousel.setActiveItem(tab.name);
    },
    reTabs(goodsInfoActiveTab) {
      this.tabVisible = false;
      this.$nextTick(() => {
        this.tabVisible = true;
        this.$nextTick(() => {
          if (goodsInfoActiveTab) this.$refs.GoodsInfoTab.goodsInfoActiveTab = goodsInfoActiveTab;
        });
      });
    },
    /* 关闭弹窗 */
    handleClose() {
      this.cancel();
      // if([5,6].includes(this.$route.query.status)){
      //   this.complete('BusinessOrderInternalCSGAdmin');
      // }else{
      //   this.complete('BusinessAbnormalOrderALL');
      // }
    },
    /** 挂起/解挂 */
    onHangUp(action) {
      this.$refs.SuspendReason.onEdit(action);
    },

    /** 添加标签 */
    onAddTags(action) {
      this.$refs.EditTags.onEdit();
    },
    /** 删除一个标签 */
    handleCloseTag(code) {
      this.$confirm(this.$t('InternalSalesOrderDetails.delete'))
        .then(_ => {
          const POST_DATA = this.cptOrderTagCodeList.filter(e => e !== code);
          this.editBaseInfoApi({ orderId: this.id, tags: POST_DATA.join() });
        })
        .catch(_ => {});
    },
    onEditOrder() {
      if (this.routeStatus === 3) {
        // 判断是否可以编辑
        orderApi.getOrderSapStatus({ innerOrderNo: encodeURIComponent(this.orderInfoVO.innerOrderNo) }).then(res => {
          if (res.failed === false) {
            this.$router.push({
              // 内部订单编辑页
              name: 'BusinessOrderInternalEditCSG',
              query: { innerOrderNo: this.orderInfoVO.innerOrderNo },
            });
          }
        });
      } else {
        this.$router.push({
          name: 'BusinessOrderInternalEditCSG',
          query: { innerOrderNo: this.orderInfoVO.innerOrderNo },
        });
      }
    },
    onCopy() {
      if (this.orderInfoVO.innerOrderNo) {
        this.$router.push({
          name: 'BusinessOrderInternalAddCSG',
          query: { innerOrderNo: this.orderInfoVO.innerOrderNo },
        });
      } else {
        this.$message.warning(
          this.$t('InternalSalesOrderDetails.error') + this.orderInfoVO.innerOrderNo,
        );
      }
    },
    // {{$t('InternalSalesOrderDetails.Modify')}}备注
    onEditRemarks(key) {
      this.$refs.EditRemarks.onEdit(key);
    },
    onConfirmReceipt() {
      this.$confirm(this.$t('InternalSalesOrderDetails.sure')).then(()=> {
        this.confirmReceiptByOrderIdApi({ orderId: this.id });
      })
    },
    // 订单级-确认收货
    editBaseInfoApi(POST_DATA) {
      orderApi.updateOrderBase(POST_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          this.$refs.EditRemarks.dialogVisible = false;
          this.$refs.EditReceiverInfo.dialogVisible = false;
          this.$refs.EditTags.dialogVisible = false;
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    // 订单级-确认收货
    confirmReceiptByOrderIdApi(POST_DATA) {
      orderApi.confirmReceiptByOrderId(POST_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    // 异常原因提示弹出框
    onEditAbnormal() {
      settingApi.getTaskInstanceMessage({innerOrderNo: this.orderInfoVO.innerOrderNo}).then(res => {
        const str = res.exceptionMessage;
        const str1 = str.substring(str.indexOf('\r\n'), str.indexOf('\n\t'));
        this.$alert(str1, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        type: 'warning',
        callback: action => {},
      });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.app-container .bj-form-item .order-remark-content {
  display: flex;
  align-items: center;
  min-width: 0;
}
.order-remark-content .order-remark-text {
  flex: 0 1 auto;
  width: auto;
  max-width: 75%;
  min-width: 0;
}
.order-remark-copy {
  flex: 0 0 auto;
  margin-left: 10px;
}
::v-deep .el-carousel__arrow {
  display: none !important;
}
.app-container-2022-2-9-11-42-08 {
  .status-now {
    font-size: 16px;
    div {
      font-size: 16px;
    }
    .bj-form-item-value {
      font-size: 18px;
    }
  }
  .status-count {
    height: 100px;
    span {
      text-align: center;
      line-height: 50px;
      font-size: 24px;
      font-weight: bold;
    }
  }
  .status-count span:after {
    content: '';
    display: block;
    width: 45px;
    border-bottom: 4px solid #534f4e;
    margin: 0 auto;
  }
  .status-count span.border-orange:after {
    border-color: #f79c01;
  }
  .status-count span.border-green:after {
    border-color: #58d071;
  }
  // 标签
  // .tags {
  // }
  .el-carousel__item:nth-child(2n) {
    background: none;
  }
  .el-carousel__item:nth-child(2n + 1) {
    background: none;
  }
  // 滚动标题
  .animation-title-box {
    // display: flex;
    // margin-top: 30px;

    .animation-title {
      // width: 80px;

      #animation-title-ul {
        // position: absolute;

        padding: 0;
        // top: 60%;
        // left: 6px;
        // display: flex;
        // flex-direction: column;

        font-size: 12px;
        background: rgba($color: #ffffff, $alpha: 1);
        // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

        list-style: none;
        li {
          display: inline-block;
          padding: 6px 4px;
        }
      }
      .fixed {
        position: fixed;
        top: 10px;
        z-index: 9;
        // right: 20px;
      }
    }
    .animation-content {
      width: calc(100% - 80px);
    }
  }

  // 订单
  .bj-col-p20:first-child {
    width: 24% !important;
  }
  .bj-col-p20 {
    width: 19% !important;
  }

  .app-container {
    width: 100%;
  }

  .bj-col-14 {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    padding-bottom: 16px;
    .el-icon-circle {
      margin-right: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 52px;
    }
  }
  .item {
    margin-right: 40px;
  }
  .flex {
    align-items: stretch;
    justify-content: space-around;
    .flex-item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: nowrap;
      flex-direction: column;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      padding: 10px 15px;
      font-size: 14px;
      color: #606266;
      line-height: 28px;
      box-sizing: border-box;
      font-weight: 700;
      max-height: 120px;
      margin-top: 16px;
      label {
        display: inline-block;
        width: 88px;
      }
    }
  }
  .flex-direction {
    flex-direction: column;
    align-items: center;
  }
  .circle {
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border-radius: 50%;
    border: 1px solid #dcdfe6;
    font-size: 20px;
  }
  .cell .el-tag {
    margin-right: 5px;
  }
  .foot-table {
    min-height: 220px;
    max-height: 480px;
    overflow-y: auto;
  }
}
.tabs {
  background-color: white;
}
.tabs .tabs-btn {
  position: absolute;
  right: 20px;
  margin-top: 6px;
  z-index: 1;
}
.isFixed {
  position: fixed;
  top: 86px;
  left: 180px;
  right: 0;
  z-index: 5; // 要小于顶部导航栏的 z-index: 9
  padding: 0 20px;
  z-index: 99;
}
.isFixed2 {
  position: fixed;
  top: 60px;
  left: 140px;
  right: 0;
  z-index: 5; // 要小于顶部导航栏的 z-index: 9
  padding: 30px 20px 0;
}
.file {
  display: flex;
  font-size: 12px!important;
}
.file .fileUpload {
  margin-left: 10px;
  line-height: 20px;
  color: #6c6c6c;
}
.fileUpload_right {
  display: flex;
}
.order-material-content {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
}
.order-material-content .bj-formItemLabel {
  flex: 0 0 auto;
}
.order-material-content .fileUpload {
  flex: 1;
  min-width: 0;
  line-height: 16px;
  padding-top: 0;
}
.order-material-actions {
  display: flex;
  justify-content: flex-end;
  flex: 0 0 80px;
  gap: 8px;
  text-align: right;
  white-space: nowrap;
}
.order-material-action {
  margin-left: 0;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 250px;
  margin-left: 5px;
}
::v-deep .avatar-uploader .el-upload {
    border: none;
  }
.fileUpload2 {
  margin: 10px 10px 0;
  width: 500px;
}
.order-material-upload {
  flex: 0 0 100%;
  margin: 8px 0 0;
}
.order-material-upload ::v-deep .el-upload-list {
  margin-top: 8px;
}
</style>
